<template>
	<div>
		<Breadcrumbs main="Products" title="Add Products" />
			<div class="container-fluid">
				<div class="row">
					<div class="col-sm-12">
						<div class="card">
							<div class="card-body">

								<form @submit.prevent="addProduct" enctype="multipart/form-data" @hidden="clearForm()">
									<div class="form theme-form">

										<div class="row">
											<div class="col-sm-6">
												<div class="mb-3">
													<label class="control-label">Title <span class="text-danger">*</span></label>
													<input class="form-control" type="text" placeholder="" v-model="product.title" v-bind:class="{ 'is-invalid': Boolean(errors.title) }" minlength="3" maxlength="200"/>
													<div v-for="(val, index) in errors.title" :key="index" class="invalid-feedback">
														<p class="mb-0">{{ val }}</p>
													</div>
												</div>
											</div>
											<div class="col-sm-6">
												<div class="mb-3">
													<label class="control-label">Price <span class="text-danger">*</span></label>													
													<input class="form-control" type="text" placeholder="" v-model="product.price" v-bind:class="{ 'is-invalid': Boolean(errors.price) }" minlength="3" maxlength="200" @keypress="decimalsOnly"/>
													<div v-for="(val, index) in errors.price" :key="index" class="invalid-feedback">
														<p class="mb-0">{{ val }}</p>
													</div>
												</div>
											</div>
										</div>

										<div class="row">
											<div class="col-sm-6">
												<div class="mb-3">
													<label class="control-label">User <span class="text-danger">*</span></label>
													<div class="search-select">
														<select class="form-select" v-model="product.user_id" v-bind:class="{ 'is-invalid': Boolean(errors.user_id) }">
															<option :value="null" disabled>-- Select User --</option>
															<option v-for="user in users" :key="user.id" :value="user.id">{{ user.name }}</option>
														</select>
													</div>
													
												</div>
											</div>
											 <div class="col-sm-6">
                                                <div class="mb-3">
                                                    <label class="control-label">Category Type <span class="text-danger">*</span></label>
                                                    <select class="form-select" v-model="product.type_id" v-bind:class="{ 'is-invalid': Boolean(errors.type_id) }" @change="fetchCategories">
                                                        <option :value="null" disabled>-- Select Category Type--</option>
                                                        <option v-for="type in category_types" :key="type.id" :value="type.id">{{ type.name }}</option>
                                                    </select>
                                                    <div v-for="(val, index) in errors.type_id" :key="index" class="invalid-feedback">
                                                        <p class="mb-0">{{ val }}</p>
                                                    </div>
                                                </div>
                                        	</div>
										</div>
										<div class="row">
											 <div class="col-sm-6">
                                                <div class="mb-3">
                                                    <label class="control-label">Category <span class="text-danger">*</span></label>
                                                    <select class="form-select" v-model="product.cat_id" v-bind:class="{ 'is-invalid': Boolean(errors.cat_id) }" @change="fetchSubCategories">
                                                        <option :value="null" disabled>-- Select Category --</option>
                                                        <option v-for="cat in categories" :key="cat.id" :value="cat.id">{{ cat.cat_name }}</option>
                                                    </select>
                                                    <div v-for="(val, index) in errors.cat_id" :key="index" class="invalid-feedback">
                                                        <p class="mb-0">{{ val }}</p>
                                                    </div>
                                                </div>
                                            </div>
										
                                           <div class="col-sm-6">
                                                <div class="mb-3">
                                                    <label class="control-label">Sub Category <span class="text-danger">*</span></label>
                                                    <select class="form-select" v-model="product.subcat_id" v-bind:class="{ 'is-invalid': Boolean(errors.subcat_id) }" @change="fetchAttributes">
                                                        <option :value="null" disabled>-- Select Sub Category --</option>
                                                        <option v-for="subcat in subcategories" :key="subcat.id" :value="subcat.id">{{ subcat.subcat_name }}</option>
                                                    </select>
                                                    <div v-for="(val, index) in errors.subcat_id" :key="index" class="invalid-feedback">
                                                        <p class="mb-0">{{ val }}</p>
                                                    </div>
                                                </div>
                                            </div>
										</div>
											<!--<div class="col-sm-6">
												<div class="mb-3">
													<label class="control-label">Brand <span class="text-danger">*</span></label>

													<select class="form-select" v-model="product.brand_id" v-bind:class="{ 'is-invalid': Boolean(errors.brand_id) }" @change="fetchModels()">
														<option :value="null" disabled>-- Select Brand --</option>
														<option v-for="brand in brands" :key="brand.id" :value="brand.id">{{ brand.brand_name }}</option>
													</select>
													<div v-for="(val, index) in errors.brand_id" :key="index" class="invalid-feedback">
														<p class="mb-0">{{ val }}</p>
													</div>
												</div>
											</div>
                                        </div>-->
                                        <div class="row">
											<!--<div class="col-sm-6">
												<div class="mb-3">
													<label class="control-label">Model <span class="text-danger">*</span></label>
													
													<select class="form-select" v-model="product.model_id" v-bind:class="{ 'is-invalid': Boolean(errors.model_id) }">
														<option :value="null" disabled>-- Select Model --</option>
														<option v-for="model in models" :key="model.id" :value="model.id">{{ model.name }}</option>
													</select>
													<div v-for="(val, index) in errors.model_id" :key="index" class="invalid-feedback">
														<p class="mb-0">{{ val }}</p>
													</div>
												</div>
											</div>-->
										
											<div class="col-sm-12">
												<div class="mb-3">
													<label class="control-label">Description <span class="text-danger">*</span></label>

													<textarea class="form-control" type="textarea" placeholder="" rows="4" max-rows="6" v-model="product.description" v-bind:class="{ 'is-invalid': Boolean(errors.description) }"></textarea>
													<div v-for="(val, index) in errors.description" :key="index" class="invalid-feedback">
														<p class="mb-0">{{ val }}</p>
													</div>
												</div>
											</div>
										</div>	

										<div class="row">
											<div class="col-sm-12">
												<div class="mb-3">
													<label class="control-label">Location <span class="text-danger">*</span></label>

													<GMapAutocomplete 
														@place_changed="setPlace" class="form-control" 
														placeholder="Search here to pick the required latitude and longitude..."
														:value="product.location">
													</GMapAutocomplete>

													<GMapMap  v-if="product.location"
														:center="center"
														:zoom="18"
														map-style-id="roadmap"
														:options="mapOptions"
														style="width: 100%; height: 30vmin"
														ref="mapRef"
														@click="handleMapClick">
															<GMapMarker 
																:position="marker.position"
																:clickable="true"
																:draggable="true"
																@drag="handleMarkerDrag"
																@click="panToMarker"
															/>
													</GMapMap > 

													<div v-for="(val, index) in errors.location" :key="index" class="invalid-feedback">
														<p class="mb-0">{{ val }}</p>
													</div>
												</div>
											</div>
										</div>

										<div class="row">
											<div class="col-sm-6">
												<div class="mb-3">
													<label class="control-label">Latitude<span class="text-danger">*</span></label>
													
													<input v-model="marker.position.lat" class="form-control" type="text" v-bind:class="{ 'is-invalid': Boolean(errors.latitude) }" minlength="3" maxlength="100" @keypress="decimalsOnly"/>
													<div v-for="(val, index) in errors.latitude" :key="index" class="invalid-feedback">
														<p class="mb-0">{{ val }}</p>
													</div>
												</div>
											</div>
											<div class="col-sm-6">
												<div class="mb-3">
													<label class="control-label">Longitude <span class="text-danger">*</span></label>

													<input v-model="marker.position.lng" type="text" class="form-control" v-bind:class="{ 'is-invalid': Boolean(errors.longitude) }" minlength="3" maxlength="100" @keypress="decimalsOnly"/>
													<div v-for="(val, index) in errors.longitude" :key="index" class="invalid-feedback">
														<p class="mb-0">{{ val }}</p>
													</div>
													
												</div>
											</div>
										</div>

										<div class="row">
											<div class="col-md-10 d-flex">
												<span style="font-size: 16px; font-weight: bold;">Attributes</span>
											</div>

											<div class="row">
												<div class="col-sm-6" v-for="(attr, index) in attributes" :key="attr.id">

													<div class="attr-wrapper" v-if="attr.type==1" :label="attr.name">
														<div class="card"><span class="attr-label">{{ attr.name }}</span>
															<div class="col attr" style="margin-top: 15px;">

																<label for="radio1" v-for="val in attr.values" :key="val.id" :value="val.id + '_' + val.value">
																	<input id="radio1" type="radio" :name="'attr' + index" :value="val.id + '_' + val.value" v-model="product_attributes[attr.type + '_' + attr.id]"/>{{val.value}} &nbsp;
																</label>
															</div>
														</div>											
													</div>

													<!-- <div class="attr-wrapper" v-if="attr.type==1" :label="attr.name">
														<div class="card"><span class="attr-label">{{ attr.name }}</span>
															<div class="col attr" style="margin-top: 15px;">
																<div class="radio-group" >
																	<input id="radio1" type="radio" v-for="val in attr.values" :key="val.id" :value="val.id + '_' + val.value"  :name="'attr' + index" v-model="product_attributes[attr.type + '_' + attr.id]"/>{{val.value}} &nbsp;
																</div>
															</div>
														</div>	
													</div> -->

													<!-- <b-form-group class="attr-wrapper" v-if="attr.type==1" :label="attr.name">											
														<b-form-radio-group class="card" :name="'attr' + index" v-model="product_attributes[attr.type + '_' + attr.id]">
															<b-form-radio v-for="val in attr.values" :key="val.id" :value="val.id + '_' + val.value">{{val.value}}</b-form-radio>	
														</b-form-radio-group>									
													</b-form-group> -->


													<div class="attr-wrapper" v-if="attr.type == 2" :label="attr.name">
													<div class="card">
														<span class="attr-label">{{ attr.name }}</span>
														<div class="col attr" style="margin-top: 15px;">
														<!-- Loop through the values and create a checkbox for each one -->
														<label v-for="val in attr.values" :key="val.id">
															<input 
															type="checkbox" 
															:name="'attr' + index" 
															
															v-model="product_attributes[attr.type + '_' + attr.id+'_' + val.id]" 
															:true-value="val.id + '_' + val.value"
															:false-value="null" />
															{{ val.value }} &nbsp;
														</label>
														</div>
													</div>
													</div>


													<div class="attr-wrapper attr" v-else-if="attr.type==3" :label="attr.name">
														<div class="card"><span class="attr-label">{{ attr.name }}</span>
															<div class="col attr" style="margin-top: 15px;">
																<input :name="'attr' + index" v-model="product_attributes[attr.type + '_' + attr.id]"/>
															</div>
														</div>
													</div>
													<div class="attr-wrapper" v-else-if="attr.type==4" :label="attr.name">
														<textarea :name="'attr' + index" rows="3" max-rows="6" v-model="product_attributes[attr.type + '_' + attr.id]"></textarea>
													</div>

													<div class="attr-wrapper" v-if="attr.type==5" :label="attr.name">
														<b-form-input v-model="grid_text" class="mb-3"></b-form-input>
														<b-form-radio-group class="button-radio" :name="'attr' + index" button-variant="outline-primary" buttons v-model="product_attributes[attr.type + '_' + attr.id]">
															<b-form-radio v-for="val in attr.values" :key="val.id" :value="val.id + '_' + val.value"  @change="setGridText($event)">{{val.value}}</b-form-radio>	
														</b-form-radio-group>								
													</div>
												</div>
											</div>
											
										</div>

										<div class="row">
											<div class="col-sm-6">
												<div class="mb-3">
													<label class="control-label">Images <span class="text-danger">*</span></label>
													
													<div class="row" v-for="(input, index) in inputs" :key="index">    
														<div class="col-md-6 form-group">    

															<input ref="fileinput" type="file" @change="setFile($event, index)" accept="image/*" class="form-control"  v-bind:class="{ 'is-invalid': Boolean(errors.image) }"/>
															<span>
																<i class="fa fa-minus-circle text-danger" @click="remove(index)" v-show="index || ( !index && inputs.length > 1)"></i>
																<i class="fa fa-plus-circle text-success" @click="add()" v-show="index == inputs.length-1"></i>
															</span>
														</div>
														<div class="col" md="6">
															<img class="image-preview" v-bind:src="input.preview_image">
														</div>
													</div>

												</div>
											</div>

											<div class="col-sm-6">
												<div class="mb-3">
													<label class="control-label">Video</label>
													<input class="form-control" type="file" placeholder="">
													<!-- <b-form-input v-model="user.email" v-bind:class="{ 'is-invalid': Boolean(errors.email) }"></b-form-input>
													<div v-for="(val, index) in errors.email" :key="index" class="invalid-feedback">
														<p class="mb-0">{{ val }}</p>
													</div> -->
												</div>
											</div>
										</div>

										<div class="row">
											
										</div>
								
										<div class="col-sm-6">
											<button class="btn btn-primary me-3" type="submit">Add</button>
											<a class="btn btn-light"  @click="clearForm">Reset</a>
											<!-- <button type="submit" class="mr-3" variant="primary">Add</button>
											<button class="" variant="light">Reset</button> -->
										</div>
									
									</div>
								</form>

							</div>
						</div>
					</div>
				</div>
			</div>
 
   </div>
</template>


<script>
import '@/assets/css/custom.css';
import {ref, onMounted} from "vue";

const address = ref('');

	export default {
		name: "AddProduct",
		setup() {
			let mapRef = ref(null);
			// onMounted

		},
		
		data() {
			
			return {
				product: {
					title: '',
					brand_id: null,
					model_id: null,
					cat_id: null,
					type_id:null,
                    subcat_id:null,
					user_id: null,
					description: '',
					price: null,
					location: '',
					latitude: null,
					longitude: null,
					video: '',
					attribute_ids: [],
					attribute_value_ids: [],
					attribute_values: [],
				},

				mapRef:'',
				address: "",
				
				marker: { position: { lat: null, lng: null } },
				center: { lat: null, lng: null },
				current_place: null,

				mapOptions: {
					disableDefaultUI: true,
				},

				users: {},
				categories: {},
				category_types: [],
                subcategories : [],
				brands: {},
				models: {},
				attributes: [],
				inputs: [
					{value: null, preview_image: null, image: null}
				],
				product_attributes: {},
				grid_text: null,
				images: [],
				keyword: '',
				visible: false,
				token: "",
				errors: {},

			};
		},
		mounted() {
			// this.$refs.address.focus();
			this.fetchUsers();
		},

		created() {
			this.fetchCategoryTypes();
			//this.fetchCategories();
			//this.fetchBrands();
			//this.fetchAttributes();
			// this.fetchModels();
			
		},

		methods: {

			add() {
				this.inputs.push({ value: null });
			},

			remove(index) {
				this.inputs.splice(index, 1);
				this.images.splice(index, 1);
			}, 

			setFile(e, index) {
				this.images.push(e.target.files[0]);
				this.inputs[index].image = e.target.files[0];
				this.inputs[index].preview_image = URL.createObjectURL(e.target.files[0]);
			},

			geolocate() {
		      navigator.geolocation.getCurrentPosition((position) => {
		         this.marker.position = {
		           lat: position.coords.latitude,
		           lng: position.coords.longitude,
		         };
		         this.panToMarker();
      		});
    		},

		   
			handleMarkerDrag(e) {
      			this.marker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
    		},

    		panToMarker() {
				this.$refs.mapRef.panTo(this.marker.position);
    		},

    		handleMapClick(e) {
				this.marker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
				console.log(e);
    		},	 

		 	setPlace(place) {
		    	this.current_place = place;
		    	if(this.current_place) {
		    		const marker = {
			    		lat: this.current_place.geometry.location.lat(),
			    		lng: this.current_place.geometry.location.lng(),
			    	};
			    	this.center = marker;
			    	this.marker.position = marker;
			    	this.product.location = place.formatted_address;
					this.product.latitude = marker.lat;
	    			this.product.longitude = marker.lng;
		    	}
		   },

			decimalsOnly(event) {
		      let keyCode = event.keyCode;
		      if (keyCode >= 48 || keyCode <= 57 || keyCode == 46 ) {
		      	return;
		      } else {
		        event.preventDefault();
		      }
		    },
		    alphaSpacesOnly(event) {
		    	let keyCode = event.keyCode;
			    if ((keyCode >= 65 && keyCode <= 90) || 
			    	(keyCode >= 97 && keyCode <= 122) ||			    	
			    	(keyCode == 32)) {
			        return;
			    } else {
			    	event.preventDefault();
			    }
		    },
		   
			getToken() {
                if (localStorage.getItem('slo_admin')) {
                    var slo_admin =  JSON.parse(localStorage.getItem('slo_admin')); 
                    
                    if(slo_admin.token) {

                        this.token = slo_admin.token;
                        this.user = slo_admin;

                    } else {
                        this.$swal("", "Failed to fetch token, please login again", "error");
                        this.$router.push({ name: "Login" });
                    }

                } else {
                    this.$swal("", "Session expired, please login again", "error");
                    this.$router.push({ name: "Login" });
                }
            },

			fetchCategoryTypes() {
				let url = "/api/products/categoryTypes";			
				this.getToken();
				this.$axios
					.get(url, { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						var responseData = res.data;
						this.category_types = responseData.data;
						console.log(this.category_types);
					})
					.catch((err) => console.log(err));
			},


			fetchCategories(event) {
                const typeId = this.product.type_id;
				let url = `/api/products/${typeId}/categories`;		
				this.getToken();
				this.$axios
					.get(url, { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						var responseData = res.data;
						this.categories  = responseData.data;
                        console.log(this.categories );
					})
					.catch((err) => console.log(err));
			},

            
			fetchSubCategories(event) {
                const categoryId = this.product.cat_id;
				let url = `/api/admin/products/${categoryId}/subcategories`;		
				this.getToken();
				this.$axios
					.get(url, { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						var responseData = res.data;
						this.subcategories  = responseData.data;
                        console.log(this.subcategories );
					})
					.catch((err) => console.log(err));
			},

			fetchBrands() {
				let url = "/api/admin/products/brands";				

				this.getToken();
				this.$axios
					.get(url, { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						var responseData = res.data;
						this.brands = responseData.data;
					})
					.catch((err) => console.log(err));
			},

			fetchModels() {
				
				let url = "/api/admin/products/models?brand_id=" + this.product.brand_id;			

				this.getToken();
				this.$axios
					.get(url, { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						var responseData = res.data;
						this.models = responseData.data;
						console.log(this.models);
					})
					.catch((err) => console.log(err));
			},

			
			 fetchUsers() {
                let url = "/api/admin/products/users?limit=0&keyword=" + this.keyword;
                this.getToken();

                this.$axios
                    .get(url, {
                        headers: { Authorization: "Bearer " + this.token },
                    })
                    .then((res) => {
                        var responseData = res.data;

                        // Check if responseData.data exists and is an array
                        if (responseData && Array.isArray(responseData.data)) {
                            this.users = responseData.data;
                            console.log(this.users);

                            this.items = [];
                            for (var i = 0; i < responseData.data.length; i++) {
                                this.items.push(responseData.data[i].name + '|' + responseData.data[i].phone_number);
                            }

                            this.visible = true;
                        } else {
                            console.error("Unexpected response format:", responseData);
                        }
                    })
                    .catch((err) => console.log(err));
            },

			fetchAttributes() {
                  const subcategoryId = this.product.subcat_id;
				let url = `/api/admin/products/${subcategoryId}/attributes`;
				this.$axios
					.get(url, {
						headers: { Authorization: "Bearer " + this.token },
					})
					.then((res) => {
						var responseData = res.data.data;
						this.attributes = responseData;
						console.log(responseData);
						
					})
					.catch((err) => console.log(err));
			},

			setUser() {
				this.keyword = event.target.options[event.target.options.selectedIndex].label;
				this.visible = false;
			},

			setVideo(event) {
				this.product.video = event.target.files[0];
			},

			setGridText(event) {
				
				let key_array = event.split("_");
				this.grid_text = key_array[1];

			},

			addProduct() {

				this.getToken();
				let formData = new FormData();
				formData.append("title", this.product.title);
				formData.append("price", this.product.price);
				formData.append("cat_id", this.product.cat_id);
				formData.append("type_id", this.product.type_id);
                formData.append("subcat_id", this.product.subcat_id);
				formData.append("user_id", this.product.user_id);
				//formData.append("brand_id", this.product.brand_id);
				//formData.append("model_id", this.product.model_id);
				formData.append("description", this.product.description);
				formData.append("location", this.product.location);
				formData.append("latitude", this.marker.position.lat);
				formData.append("longitude", this.marker.position.lng);
				formData.append("latitude", this.marker.position.lat);
				formData.append("longitude", this.marker.position.lng);
				formData.append("video", this.product.video);
			
				this.product.attribute_ids = [];
				this.product.attribute_value_ids = [];
				this.product.attribute_values = [];
				for(var key of Object.keys(this.product_attributes)) {

					let key_array = key.split("_");	      	
					
					if(key_array[0] == 3 || key_array[0] == 4) { 
						this.product.attribute_ids.push(key_array[1]);
						this.product.attribute_value_ids.push('0');
						this.product.attribute_values.push(this.product_attributes[key]);

					} else if(key_array[0] == 5) {
						
						this.product.attribute_ids.push(key_array[1]);
						this.product.attribute_value_ids.push('0');
						this.product.attribute_values.push(this.grid_text);
					} else {
						
						if(key_array[0] == 2) {
							let array = this.product_attributes[key].split("_");
							this.product.attribute_value_ids.push(array[0]);
							this.product.attribute_values.push(array[1]);
							this.product.attribute_ids.push(key_array[1]);
							
						} else {
							let array = this.product_attributes[key].split("_");
							this.product.attribute_value_ids.push(array[0]);
							this.product.attribute_values.push(array[1]);
							this.product.attribute_ids.push(key_array[1]);
						}
					}	         	
				}

	         console.log('attribute_ids', this.product.attribute_ids);
	         console.log('attribute_value_ids', this.product.attribute_value_ids);
	         console.log('attribute_values', this.product.attribute_values);


	         formData.append('attribute_value_ids', JSON.stringify(this.product.attribute_value_ids));
	         formData.append('attribute_values', JSON.stringify(this.product.attribute_values));
	         formData.append('attribute_ids', JSON.stringify(this.product.attribute_ids));

	        

				for(var j = 0; j < this.images.length; j++) {
				  	let file = this.images[j];
				   formData.append('images[' + j + ']', file);
				}

				const config = {
					headers: {
						"content-type": "multipart/form-data",
						Authorization: "Bearer " + this.token,
					},
				};

				let url;
				url = "/api/admin/products/add";

				this.$axios
					.post(url, formData, config)
					.then((response) => {
						if (response.data.status) {
							this.$swal("", response.data.message, "success");
						} else {
							this.$swal("", response.data.message, "error");
						}
						this.clearForm();
					})
					.catch((error) => {
						this.errors = {};
						if (error.response) {
							if (error.response.data.message) {
								console.log(error.response.data);
								this.errors = error.response.data.message;
								console.log(this.errors);
								
							} else {
								this.$swal("", "Something went wrong", "error");
							}
						} else {
							this.$swal("", "Something went wrong", "error");
						}
					});
			},

			clearForm() {
				this.fetchCategories();
				this.fetchBrands();
				this.fetchAttributes();
				this.product.title = "";
				this.product.description = "";
				this.product.brand_id = null;
				this.product.model_id = null;
				this.product.cat_id = null;
				this.product.user_id = null;
				this.product.price = null;
				this.product.location = '';
				this.marker.position.lat = null;
				this.marker.position.lng = null;
				this.product.video = null,
				this.inputs = [{value: null, preview_image: null}];
				this.images = [];
				this.product.attribute_ids = [];
				this.product.attribute_value_ids = [];
				this.product.attribute_values = [];
				this.product_attributes = {};
				this.errors = {};
				this.keyword = '';
			},
		},
	};
</script>
